import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchProfile,
  updateProfile,
  type Profile,
  type UpdateProfilePayload,
} from '../api/profileApi';

export const profileKeys = {
  current: ['profile', 'current'] as const,
};

interface UseProfileQueryOptions {
  enabled?: boolean;
}

export function useProfileQuery(options: UseProfileQueryOptions = {}) {
  return useQuery<Profile, Error>({
    queryKey: profileKeys.current,
    queryFn: fetchProfile,
    enabled: options.enabled ?? true,
    staleTime: 60_000,
  });
}

/** PUT /profile. На успехе кладёт свежий профиль в кеш — AppGate подхватит
 *  его (useEffect на profileQuery.data) и обновит auth-store/язык. */
export function useUpdateProfileMutation() {
  const qc = useQueryClient();
  return useMutation<Profile, Error, UpdateProfilePayload>({
    mutationFn: updateProfile,
    onSuccess: (profile) => {
      qc.setQueryData(profileKeys.current, profile);
    },
  });
}
